export default __webpack_public_path__ + "static/media/sticker-O.893ffdd1.png";